import { isEmpty, omitBy } from 'lodash';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export type PageInfo = Record<string, string>;

export const usePageInfo = (): PageInfo => {
    const { pathname, hash, search } = useLocation();
    const params = useParams<Record<string, string>>();

    return useMemo(() => {
        // Strip param values from pathname to get the route pattern
        const basePath = Object.values(params).reduce<string>(
            (path, param) => (param ? path.replace(`/${param}`, '') : path),
            pathname
        );
        const searchParams = Object.fromEntries(new URLSearchParams(search));

        return omitBy(
            {
                page: basePath,
                page_section: hash.replace('#', ''),
                ...params,
                ...searchParams,
            },
            isEmpty
        );
    }, [pathname, hash, search, params]);
};
